<p class="no-data-card-header">{{ header }}</p>
<p class="no-data-card-content">{{ text }}</p>
<button mat-button (click)="backClicked()">Tilbake</button>
<button mat-button (click)="homeClicked()" mat-dialog-close>
  Gå til prosjektliste
</button>
